/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Pagination_NextInputs */

const en_audit_pagination_next = /** @type {(inputs: Audit_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const pt_br2_audit_pagination_next = /** @type {(inputs: Audit_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Audit_Pagination_NextInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_pagination_next = /** @type {((inputs?: Audit_Pagination_NextInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Pagination_NextInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_pagination_next(inputs)
	return pt_br2_audit_pagination_next(inputs)
});